import { createAction } from '@reduxjs/toolkit';

export const addNavigation = createAction('navigation/add');
